import { Fragment } from 'react';
import { ShowWithTourType } from '@api';
import { ArtistAnchor, TourAnchor, VenueAnchor } from '@common';
import { Group, Stack, Text } from '@mantine/core';
import { getShowArtists } from './helpers';

type ShowPropsType = {
  show: ShowWithTourType;
};

export const ShowTableCell: React.FC<ShowPropsType> = ({ show }) => {
  const artists = getShowArtists(show);

  return (
    <Stack gap={0}>
      <Text>
        {artists.map((artist, index) => (
          <Fragment key={artist.id}>
            <ArtistAnchor key={artist.id} artist={artist} />
            {index < artists.length - 1 && ' & '}
          </Fragment>
        ))}
      </Text>
      <TourAnchor tour={show.tour} />
      <Group gap={0}>
        <VenueAnchor venue={show.venue} />
        {show.city && <Text>, {show.city}</Text>}
      </Group>
    </Stack>
  );
};
